'use client';

import { useClientLocale, useClientTranslation } from '@bts-web/utils-lokalise';
import { TFunction } from 'i18next';
import { getSavingsPlanDetailsTranslations } from '../utils/getSavingsPlanDetailsTranslations';
import { SavingsPlansDetailsContent } from '../SavingPlansDetailsContent/SavingsPlansDetailsContent';
import { useSavingsPlanDetails } from '../hooks/useSavingsPlanDetails.use-client';
import { TransactionDetailsLayout } from '../../../transaction-details/TransactionDetailsLayout/TransactionDetailsLayout';
import { TransactionDetailsSkeleton } from '../../../transaction-details/TransactionDetailsSkeleton/TransactionDetailsSkeleton';
import { Drawer } from '../../../common/components/Drawer/Drawer';
import { ComponentProps } from 'react';
import { SavingsPlansLatestTransactionsContent } from '../../SavingsPlansLatestTransactionsContent/SavingsPlansLatestTransactionsContent';

export const transactionDetailsDrawerId = 'transaction_details_drawer';

interface SavingsPlanDetailsDrawerProps {
  savingsPlanId: string;
}

export const SavingsPlanDetailsDrawer = ({
  savingsPlanId,
}: SavingsPlanDetailsDrawerProps) => {
  const { savingsPlan, isDataLoading, savingsPlanTransactions } =
    useSavingsPlanDetails({
      savingsPlanId,
    });

  const locale = useClientLocale();

  const { t } = useClientTranslation();

  const translations = getSavingsPlanDetailsTranslations(t as TFunction);

  return (
    <Drawer title={translations.savingsPlanDetails}>
      <TransactionDetailsLayout>
        {isDataLoading || !savingsPlan ? (
          <TransactionDetailsSkeleton />
        ) : (
          <SavingsPlansDetailsContent
            savingsPlan={savingsPlan}
            locale={locale}
            translations={translations}
            latestTransactionData={
              savingsPlanTransactions as ComponentProps<
                typeof SavingsPlansLatestTransactionsContent
              >['latestTransactionsData']
            }
          />
        )}
      </TransactionDetailsLayout>
    </Drawer>
  );
};
